<template>
  <!-- eslint-disable max-len -->
  <main class="u-container">
    <!-- Abandoment email unsub - Auto unsub -->
    <p
      v-if="abandonmentEmail"
      ref="abandonment"
      class="py-6"
    >
      Your email will be unsubscribed from Abandonment emails.
    </p>
    <!-- Regular email unsub -->
    <template v-else>
      <p
        v-if="error"
        ref="error"
        class="py-6"
      >
        There was an error unsubscribing.
      </p>
      <p
        v-else-if="success"
        ref="success"
        class="py-6"
      >
        {{ email || 'Your email' }} has been unsubscribed. Please allow 7-10 days for your opt out to take effect.
      </p>
      <form
        v-else
        ref="unsubForm"
        @submit.prevent="unsubscribe"
      >
        <h1 class="font-bold">
          Change-of-Address Email Subscription Management Center
        </h1>
        <p class="mt-2">
          Welcome to the USPS Change-of-Address Email Subscription Management Center.
        </p>
        <h2 class="mt-4 font-bold">
          Unsubscribe
        </h2>
        <p class="mt-2">
          Remove me from all USPS mail forwarding notification emails. I understand that I am not unsubscribing from other units within the United States Postal Service. In addition, should I file a Change-of-Address with the U.S. Postal Service in the future, notification emails associated with that Change-of-Address will be sent to the email address I provided.
        </p>
        <div class="flex justify-center">
          <button
            id="email-unsubscribe"
            type="submit"
            class="c-btn mt-6"
          >
            Unsubscribe
          </button>
        </div>
      </form>
    </template>
  </main>
</template>

<script>
import jwtDecode from 'jwt-decode';

export default {
  name: 'EmailUnsubscribe',
  data() {
    return {
      email: '',
      orderUuid: '',
      ref: '',
      token: '',

      error: false,
      success: false,
    };
  },
  computed: {
    abandonmentEmail() {
      return this.ref === '10034unsub-addr' || this.ref === '10034unsub-lbl';
    },
  },
  async mounted() {
    this.orderUuid = this.$route.params.orderUuid || '';
    this.ref = this.$route.query.ref || '';
    this.token = this.$route.query.token || '';

    if (this.token) {
      const { email } = jwtDecode(this.token);
      this.email = email;
    }

    if (this.token && !this.email) {
      this.error = true;
    }

    // Abandon email refs get automatically unsub'd
    if (this.abandonmentEmail) {
      await this.unsubscribe();
    }
  },
  methods: {
    async unsubscribe() {
      const { error } = await this.$coa.unsubscribe(this.orderUuid, this.ref, this.token);

      if (error) {
        this.error = !!error;
        return;
      }

      this.success = true;
    },
  },
};
</script>
